import React from 'react';
import { Facebook, Instagram, Twitter, Youtube, Heart } from 'lucide-react';
import { contactInfo, contactInfo1 } from '../mockData';
import { useNavigate } from 'react-router-dom';

export const Footer = () => {
  const navigate = useNavigate();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/banquets', label: 'Banquets & Catering' },
    { path: '/about', label: 'About Us' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' },
    { path: '/reservations', label: 'Reservations' }
  ];

  const socialLinks = [
    { icon: Facebook, label: 'Facebook', url: '#' },
    { icon: Instagram, label: 'Instagram', url: '#' },
    { icon: Twitter, label: 'Twitter', url: '#' },
    { icon: Youtube, label: 'Youtube', url: '#' }
  ];

  return (
    <footer className="bg-gradient-to-b from-amber-900 to-amber-950 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About Section */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-amber-300">
              Just Bengali
            </h3>
            <p className="text-amber-100/80 leading-relaxed mb-4">
              Experience the authentic taste of Bengal with our traditional recipes and warm hospitality.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  className="w-10 h-10 bg-amber-800 hover:bg-amber-700 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          {/* <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-300">
              Quick Links
            </h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-amber-100/80 hover:text-amber-300 transition-colors duration-300 hover:translate-x-1 inline-block"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Opening Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-300">
              Opening Hours
            </h4>
            <div className="space-y-2 text-amber-100/80">
              <p>Monday - Sunday</p>
              <p className="font-semibold text-amber-200">11:00 AM - 11:00 PM</p>
              <p className="mt-4 text-sm">
                Open all days including holidays
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-300">
              Contact Info
            </h4>
            <ul className="space-y-3 text-amber-100/80">
              <li className="flex items-start">
                <span className="mr-2">📍</span>
                <span>{contactInfo.location}</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📞</span>
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📧</span>
                <span>{contactInfo.email}</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-300">
              Contact Info
            </h4>
            <ul className="space-y-3 text-amber-100/80">
              <li className="flex items-start">
                <span className="mr-2">📍</span>
                <span>{contactInfo1.location}</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📞</span>
                <span>{contactInfo1.phone}</span>
              </li>
              <li className="flex items-center">
                <span className="mr-2">📧</span>
                <span>{contactInfo1.email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-amber-800 mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-amber-100/70 text-sm">
            © 2026 Just Bengali. All Rights Reserved.
          </p>
          <p className="text-amber-100/70 text-sm flex items-center">
            Made with <Heart className="w-4 h-4 mx-2 text-red-400 fill-current" /> by Just Bengali Team
          </p>
        </div>
      </div>
    </footer>
  );
};
